import { FormikValues } from 'formik';

import {
  BroadcastNotificationType,
  IAdminSendBroadcastApiParams,
} from '@pharmaplan/common';

import {
  emptyNavigationModel,
  toNavigationModel,
} from './BroadcastNavigationFields/helper';
import { toSendAt } from './BroadcastScheduleFields/helper';

interface IBroadcastParamsSource {
  values: FormikValues;
  type: BroadcastNotificationType;
  hasNavigation: boolean;
}

// ONE PAYLOAD FOR BOTH SENDING AND UPDATING, SO THE TWO CANNOT DRIFT APART
export const toBroadcastParams = ({
  values,
  type,
  hasNavigation,
}: IBroadcastParamsSource): IAdminSendBroadcastApiParams => {
  const {
    message,
    subject,
    groupIds,
    footer,
    navigateTo,
    shiftUrl,
    pharmacyId,
    sendAtDate,
    sendAtTime,
  } = values ?? {};

  const navigationModel = hasNavigation
    ? toNavigationModel({ navigateTo, shiftUrl, pharmacyId })
    : emptyNavigationModel;

  return {
    message,
    subject,
    type,
    groupIds,
    footer,
    ...navigationModel,
    sendAt: toSendAt({ sendAtDate, sendAtTime }),
  };
};
